import React, { memo } from 'react'



const Status = ({ status }) => {
    return (
        <div
        className={`
            ${
                status === 'pending' || status === 'running' || status === 'inActive' || status === 'blocked'
                ? 
                    'bg-yellow-500 bg-opacity-30 text-[#FFE500]'
                : 
                status === 'completed' || status === 'approved' || status === 'claimed' || status === 'active' || status === 'accepted'
                ?
                    'bg-green-500 bg-opacity-30 text-[#33FF00]'
                : 
                status === 'declined' || status === 'cancelled' || status === 'rejected' || status === 'expired' || status === 'deleted'
                ? 
                    'bg-red-500 bg-opacity-30 text-[#FF0000]'
                : 
                    ''
            }
            text-sm px-2 rounded-md flex items-center gap-1 py-1 pb-1.5 font-medium w-fit capitalize
        `}
        >
            <span>
                {status}
            </span>
        </div>
    )
}

export default memo(Status)